module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom4.ffbd3333.jpg";